import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import ReportDetailsHeader from "./ReportDetailsHeader";
import { ReportsWrapper } from "./styles";
import ReportDetailsBody from "./ReportDetailsBody";
import ReportDetailsFooter from "./ReportDetailsFooter";
import { useAppDispatch, useAppSelector } from "../../utils/hooks/redux";
import { Alert } from "antd";
import { setAdminUsers } from "../../redux/features/user/userSlice";
import { useFetchReport } from "../../utils/hooks/useFetchReport";
import { setKeyValue } from "../../redux/features/report/reportSlice";

const ReportDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const { report, status, error, versionData } = useAppSelector((state) => state.report);
  const fetchReport = useFetchReport();

  useEffect(() => {
    if (id) {
      fetchReport(id);
    }
  }, [id, fetchReport]);

  useEffect(() => {
    return () => {
      dispatch(setKeyValue({ key: "report", value: null }));
      dispatch(setAdminUsers([]));
    }
  }, []);

  return (
    <>
      {
        status === "failed" ? <Alert type="error" showIcon message={error} />
          :
          <>
            <ReportDetailsHeader isLoading={status === 'loading'} report={report} versionData={versionData} />
            <ReportDetailsFooter />
            <ReportsWrapper>
              <ReportDetailsBody isLoading={status === 'loading'} report={report} versionData={versionData} />
            </ReportsWrapper>
          </>
      }
    </>
  );
};

export default ReportDetails;
